// eslint-disable-next-line import/no-cycle
import {
    BOOKING_LOAD_BOOKING_LIST,
    BOOKING_LOAD_BOOKING_LIST_SUCCESS,
    BOOKING_LOAD_BOOKING_LISTS,
    BOOKING_LOAD_BOOKING_LISTS_SUCCESS,
    BOOKING_LOAD_ALL_PAYMENT_BOOKING_LIST_SUCCESS,
    BOOKING_LOAD_REVIEW,
    BOOKING_LOAD_REVIEW_SUCCESS,
    BOOKING_UPDATE_SHOW_REVIEW,
    BOOKING_UPDATE_SHOW_REVIEW_SUCCESS,
    BOOKING_LOAD_REVIEW_CHAT,
    BOOKING_LOAD_REVIEW_CHAT_SUCCESS,
    BOOKING_SEND_REVIEW_CHAT_ADMIN,
    BOOKING_SEND_REVIEW_CHAT_ADMIN_SUCCESS,
    BOOKING_READ_REVIEW_CHAT,
    BOOKING_READ_REVIEW_CHAT_SUCCESS
} from '../actions';

// // -------------------- Booklist --------------------- //
export const getBooklist = (data, token) => ({
    type: BOOKING_LOAD_BOOKING_LIST,
    payload: data,
    token
});
export const getBooklistSuccess = (data) => ({
    type: BOOKING_LOAD_BOOKING_LIST_SUCCESS,
    payload: data
});

export const getBooklists = (data, token) => ({
    type: BOOKING_LOAD_BOOKING_LISTS,
    payload: data,
    token
});
export const getBooklistsSuccess = (data) => ({
    type: BOOKING_LOAD_BOOKING_LISTS_SUCCESS,
    payload: data
});

export const getAllPaymentBookingSuccess = (data) => ({
    type: BOOKING_LOAD_ALL_PAYMENT_BOOKING_LIST_SUCCESS,
    payload: data
});

export const getReview = (data, token) => ({
    type: BOOKING_LOAD_REVIEW,
    payload: data,
    token
});

export const getReviewSuccess = (data) => ({
    type: BOOKING_LOAD_REVIEW_SUCCESS,
    payload: data
});

export const updateShowReview = (data, token) => ({
    type: BOOKING_UPDATE_SHOW_REVIEW,
    payload: data,
    token,
});

export const updateShowReviewSuccess = (data) => ({
    type: BOOKING_UPDATE_SHOW_REVIEW_SUCCESS,
    payload: data,
});

export const getReviewChat = (data, token) => ({
    type: BOOKING_LOAD_REVIEW_CHAT,
    payload: data,
    token,
});

export const getReviewChatSuccess = (data) => ({
    type: BOOKING_LOAD_REVIEW_CHAT_SUCCESS,
    payload: data,
});

export const sendReviewChatAdmin = (data, token) => ({
    type: BOOKING_SEND_REVIEW_CHAT_ADMIN,
    payload: data,
    token,
});


export const sendReviewChatAdminSuccess = (data) => ({
    type: BOOKING_SEND_REVIEW_CHAT_ADMIN_SUCCESS,
    payload: data,
});

export const readReviewChat = (data, token) => ({
    type: BOOKING_READ_REVIEW_CHAT,
    payload: data,
    token,
});

export const readReviewChatSuccess = (data) => ({
    type: BOOKING_READ_REVIEW_CHAT_SUCCESS,
    payload: data,
});


